import React from "react"
import { useRouteError } from "react-router-dom"

const ErrorPage: React.FC = () => {
  const error: any = useRouteError()
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <div className="text-center">
        <h1>Oops!</h1>
        Something went wrong
        <h1>{error?.status}</h1>
      </div>
    </div>
  )
}

export default ErrorPage
